import React from "react";
import SecondaryButtonAccent from "../../components/Buttons/SecondaryButtonAccent";
import ProfilePicture from "../../components/App/ProfilePicture";
import { COLORS } from "../../config";
import ExtLinkIcon from "../../components/Icons/solid/ExtLinkIcon";
import { useHistory } from "react-router";

function PatientDetails({ treatmentInfo }) {
  const history = useHistory();

  const STYLES_DIV = {
    minWidth: "500px",
  };

  return (
    <div
      className="bg-white rounded shadow flex  mb-4 2xl:mb-0 flex-col p-10 flex-grow h-80"
      style={STYLES_DIV}
    >
      <div className="flex justify-between">
        <h1 className="mb-5 text-2xl text-secondary">Patients details</h1>
        <SecondaryButtonAccent
          onClick={() =>
            history.push(
              "/manage-patients/scans/" + treatmentInfo.patient_id._id
            )
          }
          text="Patient scans"
          icon={<ExtLinkIcon fill={COLORS.colorPrimary} />}
        />
      </div>
      <div className="flex items-center h-full">
        <div className="">
          <ProfilePicture
            className={"h-24 w-24 text-4xl"}
            user={treatmentInfo.patient_id}
          />
        </div>
        <div className="mx-auto grid grid-cols-2 gap-y-2 gap-x-8">
          <label>First Name:</label>
          <span className="font-semibold">
            {treatmentInfo.patient_id.first_name}
          </span>
          <label>Last Name:</label>
          <span className="font-semibold">
            {treatmentInfo.patient_id.last_name}
          </span>
          <label>Gender:</label>
          <span className="font-semibold"> {treatmentInfo.patient_id.sex}</span>
          <label>City:</label>
          <span className="font-semibold">
            {treatmentInfo.patient_id.location.city}
          </span>
        </div>
      </div>
    </div>
  );
}

export default PatientDetails;
